module.exports = __webpack_public_path__ + "img/logo.2da38c83.svg";